<template>
  <div class="container-box">
    <div class="header">收银台</div>
    <div class="body" v-if="orderInfo.id || true">
      <div class="base-info">
        <img class="logo" v-if="showTbBtn" src="https://oss.wangyyapp.com/Foj36QGtNK-vcWqv15ooEGDBa24t" alt="" />
        <img class="logo" v-else src="https://oss.wangyyapp.com/FpwE0tXpe_crNt6JOZPIDQBeFZsZ" alt="" />
        <div class="amount">
          <span>¥</span>
          <span>{{ orderInfo.amount.toFixed(2) }}</span>
        </div>
        <div class="count-down" v-if="time > '0'">
          <span>支付剩余时间：</span>
          <span>{{ time }}</span>
        </div>
        <div class="order-no">订单号：{{ orderInfo.id }}</div>
        <div class="qr-code-box" v-if="showQrCode">
          <img class="qr-code" :class="{ blur: time <= '0' }" :src="orderInfo.sourceUrl" alt="" />
          <div class="time-out" v-if="time <= '0'">当前二维码已失效</div>
        </div>
      </div>
      <template v-if="time > '0'">
        <div class="merge-tip" v-if="!showTbBtn">注：复制金额打开支付宝，粘贴支付，即可秒到</div>
        <div class="btn copy" v-if="isJumpAlipay" @click="copy">
          <span>复制金额</span>
        </div>
        <div class="btn tb" v-if="showTbBtn" @click="openAlipay">
          <span>打开淘宝</span>
        </div>
        <div class="btn" v-else-if="!isJumpAlipay">
          <span>截图保存相册，打开支付宝扫一扫</span>
        </div>
        <div class="btn" v-else @click="openAlipay">
          <span>打开支付宝</span>
        </div>
        <div class="swiper-core">
          <div class="swiper-title" v-if="!showTbBtn">步骤图</div>
          <van-swipe class="swiper-container" :autoplay="3000" indicator-color="white">
            <van-swipe-item>
              <img src="https://oss.wangyyapp.com/FhioUL11HGm0DO-_2lYijtNIKVeN" alt="" />
            </van-swipe-item>
            <van-swipe-item>
              <img src="https://oss.wangyyapp.com/FmDOJeJaaeLsEAVB5y-2U4EkNC7d" alt="" />
            </van-swipe-item>
          </van-swipe>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
  import AJAX from "@/utils/AJAX.js";
  import dayjs from "dayjs";
  import VueQr from "vue-qr";
  import {Toast} from "vant";
  export default {
    components: {
      VueQr,
    },
    data() {
      return {
        countDownInterval: 0,
        tradeUserCheckInterval: 0,
        orderInfo: {
          amount: 0
        },
        time: '',
        imgUrlBase64: '',
        isLongClick: false,
        longClickTimer: null,
        isJumpAlipay: false,
        isCopySuccess: false,
      }
    },
    computed: {
      showQrCode() {
        const { qrCodeType } = this.orderInfo;
        return ['zzm', 'dfm'].includes(qrCodeType) && false;
      },
      showTbBtn() {
        const { qrCodeType, url } = this.orderInfo;
        return qrCodeType === 'dfm' && url?.startsWith('https://m.tb.cn');
      }
    },
    mounted() {
      AJAX.getHandling({
        itemNames: 'task_2026_cash_order_jump_alipay,task_2026_cash_order_jump_alipay_auto'
      }).then((res) => {
        const { task_2026_cash_order_jump_alipay, task_2026_cash_order_jump_alipay_auto } = res.result;
        this.isJumpAlipay = task_2026_cash_order_jump_alipay === '1'
        this.getCodeOrderInfo();
      })
    },
    destroyed() {
      this.clearInterval();
    },
    methods: {
      getCodeOrderInfo(autoOpen = false) {
        const { id } = this.$route.query;
        AJAX.getCodeOrderInfo({ id })
            .then((res) => {
              if (res.success) {
                this.orderInfo = res.result;
                this.downloadImageUrlBase64();
                this.countDownTime();
                if (this.time > '0') {
                  this.countDownInterval = setInterval(this.countDownTime, 1000);
                  if (autoOpen) {
                    this.openAlipay();
                  }
                }
                this.tradeUserCheck();
                this.tradeUserCheckInterval = setInterval(this.tradeUserCheck, 60000);
              }
            });
      },
      tradeUserCheck() {
        const { id } = this.$route.query;
        AJAX.tradeUserCheck({ id });
      },
      countDownTime() {
        if (this.orderInfo.id) {
          const { createTime, effectiveTime } = this.orderInfo;
          const diff = dayjs(createTime).add(effectiveTime, 'minutes').diff(dayjs(), 'second');
          if (diff <= 0) {
            this.clearInterval();
            this.time = '-1';
            return;
          }
          const minutes = Math.floor((diff % 3600) / 60);
          const seconds = diff % 60;
          this.time = `${minutes}分${seconds}秒`;
        }
      },
      clearInterval() {
        if (this.countDownInterval) {
          clearInterval(this.countDownInterval); // 倒计时结束
        }
        if (this.tradeUserCheckInterval) {
          clearInterval(this.tradeUserCheckInterval); // 倒计时结束
        }
      },
      detectDevice() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {
          return 'android';
        }
        // 必须先判断Android，因为某些Android用户代理同时包含iOS的标识
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return 'ios';
        }
        return 'unknown';
      },
      async openAlipay() {
        // if (!this.isCopySuccess) {
        //   Toast({
        //     type: 'text',
        //     message: '请复制金额，点击去支付粘贴金额确认支付即可',
        //     position: 'middle'
        //   });
        //   return;
        // }
        const { qrCodeType, url } = this.orderInfo;
        if (qrCodeType === 'zzm') {
          window.location.href = `alipays://platformapi/startapp?appId=20000067&url=${encodeURIComponent(url)}`;
        } else if (qrCodeType.startsWith('dfm')) {
          if ((url.startsWith('https://qr.alipay.com') || url.startsWith('https://render.alipay.com'))) {
            const detectDevice = this.detectDevice();
            if (detectDevice === 'unknown') {
              window.location.href = `alipays://platformapi/startapp?appId=20000067&url=${encodeURIComponent(url)}`;
            } else {
              const urlParams = new URLSearchParams(new URL(url).search);
              const bizNo = urlParams.get('biz_no').split('_')[0];
              window.location.href = `alipays://platformapi/startapp?appId=20000067&url=https%3A%2F%2Fds.alipay.com%2F%3FappId%3D20000125%26orderSuffix%3Dapp_name%253D%2522alipay%2522%2526trade_no%253D%2522${bizNo}%2522%2526bizcontext%253D%2522%257B%2522app%2522%253A%2522%2522%252C%2522channel%2522%253A%2522%2522%252C%2522domain%2522%253A%2522render.alipay.com%2522%252C%2522extInfo%2522%253A%257B%2522ap_link_token%2522%253A%2522%2522%257D%252C%2522isThirdDomain%2522%253Afalse%252C%2522sc%2522%253A%2522jsapi%2522%252C%2522useScan%2522%253A%2522camera%2522%257D%2522%2526biz_type%253D%2522share_pp_pay%2522%2526biz_sub_type%253D%2522peerpay_trade%2522%2526display_pay_result%253D%2522true%2522%2526appenv%253D%2522system%253D${detectDevice}%255Eappid%253Dalipay%255Eversion%253D10.7.16.8000%2522`;
            }
          } else if (url.startsWith('https://m.tb.cn')) {
            window.location.href = `tbopen://m.taobao.com/tbopen/index.html?h5Url=${encodeURIComponent(url)}`;
          }
        }
      },
      copy() {
        this.$copyText(`${this.orderInfo.amount}`).then(() => {
          this.isCopySuccess = true;
          Toast({
            type: 'success',
            message: '金额复制成功',
            position: 'bottom'
          });
        });
      },
      downloadImageUrlBase64() {
        // const that = this;
        // AJAX.downloadFileBase64(that.orderInfo.sourceUrl).then(res => {
        //   console.log( res)
        //   const reader = new window.FileReader();
        //   reader.readAsDataURL(res);
        //   reader.onload = function() {
        //     that.imgUrlBase64 = reader.result
        //   }
        // })
      },
    }
  }
</script>

<style scoped>
  .container-box {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f5f5f5;
  }
  .header {
    width: 100%;
    height: 48px;
    background: #fff;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    font-size: 20px;
    font-weight: 600;
    line-height: 48px;
    text-align: center;
    color: rgba(0, 0, 0, 0.85);
  }
  .body {
    width: calc(100% - 24px);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 12px;
    .base-info {
      width: 100%;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      padding: 32px 0;
    }
    .logo {
      width: 56px;
      height: 56px;
    }
    .amount {
      position: relative;
      display: flex;
      align-items: baseline !important;
      margin-top: 12px;
      font-size: 32px;
      font-weight: bold;
      line-height: 48px;
      text-align: center;
      span:first-child {
        margin-right: 4px;
        font-size: 18px;
        font-weight: 500;
        line-height: 26px;
        color: rgba(0, 0, 0, 0.85);
      }
      span:last-child {
        font-size: 30px;
        font-weight: 500;
        line-height: 38px;
        color: rgba(0, 0, 0, 0.85);
      }
      .copy {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        height: 32px;
        margin-left: 12px;
        border-radius: 4px;
        padding: 0 12px;
        background: #FFEDD5;
        font-size: 16px;
        font-weight: bolder;
        line-height: 32px;
        text-align: center;
        color: #FF4D4F;
      }
      img {
        position: absolute;
        right: -48px;
        top: -48px;
        animation: breathing 1.5s infinite;
      }
    }
    .count-down {
      height: 30px;
      margin-top: 8px;
      padding: 0 20px;
      text-align: center;
      border-radius: 30px;
      background: #f2f2f2;
      font-size: 12px;
      line-height: 30px;
      color: #FF4D4F;
      color: rgba(0, 0, 0, 0.85);
    }
    .order-no {
      margin-top: 8px;
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      color: rgba(0, 0, 0, 0.65);
    }
    .qr-code-box {
      position: relative;
      display: flex;
      justify-content: center;
      width: 200px;
      height: 200px;
      margin-top: 12px;
      border-radius: 40px;
      overflow: hidden;
      .qr-code {
        position: absolute;
        bottom: -20%;
        width: 150%;
        object-fit: cover;
        &.blur {
          filter: blur(10px);
        }
      }
      .time-out {
        width: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateY(-50%) translateX(-50%);
        font-size: 20px;
        font-weight: 500;
        line-height: 24px;
        text-align: center;
        color: #FF4D4F;
      }
    }
    .merge-tip {
      margin-top: 12px;
      font-size: 13px;
      font-weight: bolder;
      line-height: 22px;
      color: #F5222D;
    }
    .tip {
      margin-top: 24px;
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      color: #666666;
    }
    .btn {
      width: 90%;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 12px;
      border-radius: 56px;
      background: #1876FD;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: #FFFFFF;
      &.copy {
        background: #DCEFFF;
        border: 1px solid #94CBFF;
        color: #FFFFFF;
        color: rgba(0, 0, 0, 0.85);
      }
      &.tb {
        background-color: #FC8732;
      }
      img {
        pointer-events: none;
        width: 28px !important;
        height: 28px !important;
        margin-right: 8px;
      }
    }
    .swiper-core {
      width: 100%;
      margin-top: 24px;
      padding-top: 12px;
      border-radius: 8px;
    }
    .swiper-title {
      height: 48px;
      background-color: #ffffff;
      line-height: 48px;
      text-align: center;
      font-size: 18px;
      font-weight: bolder;
      border-radius: 8px 8px 0 0;
    }
    .swiper-container {
      width: 100%;
    }
    .swiper-container img {
      width: 100%;
    }
  }

  @keyframes breathing {
    0% { transform: rotate(225deg) translateY(0); opacity: 1; }
    50% { transform: rotate(225deg) translateY(-20px); opacity: 1; }
    100% { transform: rotate(225deg) translateY(0); opacity: 1; }
  }
</style>
